"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __spreadArray = this && this.__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) {
    to[j] = from[i];
  }
  return to;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var reconnect_js_1 = require("reconnect.js");
var antd_1 = require("antd");
var query_string_1 = __importDefault(require("query-string"));
var core_1 = require("@rjsf/core");
// @ts-ignore
var antd_2 = require("@rjsf/antd");
var JStorageCompat_1 = require("../Actions/JStorageCompat");
var index_1 = require("../index");
var ChevronLeft_1 = require("@styled-icons/feather/ChevronLeft");
var RjsForm = core_1.withTheme(antd_2.Theme);
var BulkWriteFormModal = function BulkWriteFormModal(props) {
  var visible = props.visible,
    _onOk = props.onOk,
    onCancel = props.onCancel,
    bulkWriteFormSpec = props.bulkWriteFormSpec;
  var _a = react_1.default.useState({}),
    values = _a[0],
    setValues = _a[1];
  var _b = bulkWriteFormSpec.schema,
    schema = _b === void 0 ? {} : _b,
    _c = bulkWriteFormSpec.uiSchema,
    uiSchema = _c === void 0 ? {} : _c;
  return react_1.default.createElement(antd_1.Modal, {
    visible: visible,
    onOk: function onOk(e) {
      _onOk(e, values);
    },
    onCancel: onCancel
  }, react_1.default.createElement(RjsForm, {
    schema: schema,
    uiSchema: uiSchema,
    formData: values,
    onChange: function onChange(_a) {
      var formData = _a.formData;
      setValues(formData);
    },
    onError: function onError(errors) {
      console.log('errors', errors);
    }
  }, react_1.default.createElement("div", null)));
};
function GenericResource(props) {
  var _this = this;
  var AppActions = reconnect_js_1.useOutlet('actions')[0];
  var spec = props.spec,
    location = props.location,
    collection = props.collection,
    renderDetail = props.renderDetail,
    renderHeader = props.renderHeader,
    renderCreateButton = props.renderCreateButton,
    renderDetailButton = props.renderDetailButton,
    renderDeleteButton = props.renderDeleteButton,
    renderCustomSection = props.renderCustomSection,
    resourceTableProps = props.resourceTableProps,
    _onCreate = props.onCreate,
    onGoToDetail = props.onGoToDetail,
    _a = props.querySpec,
    querySpec = _a === void 0 ? {} : _a,
    _b = props.style,
    style = _b === void 0 ? {} : _b,
    _c = props.canBulkWrite,
    canBulkWrite = _c === void 0 ? false : _c,
    _d = props.bulkWriteFormSpec,
    bulkWriteFormSpec = _d === void 0 ? {} : _d;
  var params = query_string_1.default.parse(location.search);
  var action = params.action;
  var _e = react_1.default.useState([]),
    records = _e[0],
    setRecords = _e[1];
  var _f = react_1.default.useState(null),
    selectedRecord = _f[0],
    setSelectedRecord = _f[1];
  var _g = react_1.default.useState(0),
    totalRecords = _g[0],
    setTotalRecords = _g[1];
  var _h = react_1.useState(false),
    bulkWriteModalVisible = _h[0],
    setBulkWriteModalVisible = _h[1];
  var _j = react_1.useState([]),
    bulkSelectedRecords = _j[0],
    setBulkSelectedRecords = _j[1];
  var id = (params === null || params === void 0 ? void 0 : params[spec.primaryKey]) || '';
  // all params related to how we perform query, such as search, sort, and paging
  var _k = querySpec.pageSizeOptions,
    pageSizeOptions = _k === void 0 ? null : _k,
    _l = querySpec.sortOptions,
    sortOptions = _l === void 0 ? null : _l,
    _m = querySpec.canSearch,
    canSearch = _m === void 0 ? false : _m,
    _o = querySpec.filters,
    filters = _o === void 0 ? [] : _o,
    _p = querySpec.searchPlaceHolder,
    searchPlaceHolder = _p === void 0 ? '' : _p;
  var _q = react_1.default.useState({
      keyword: '',
      filter: {},
      sort: sortOptions ? sortOptions[0].value : '',
      pageSize: pageSizeOptions && pageSizeOptions[0] || 0,
      paging: {
        offset: 0,
        limit: pageSizeOptions && pageSizeOptions[0] || 0
      },
      extraQueries: {}
    }),
    queryState = _q[0],
    setQueryState = _q[1];
  // generate all setters from the outlet
  var setKeyword = function setKeyword(keyword) {
    setQueryState(function (prevQueryState) {
      var nextState = __assign({}, prevQueryState);
      return __assign(__assign({}, nextState), {
        keyword: keyword
      });
    });
  };
  var setSort = function setSort(sort) {
    setQueryState(function (prevQueryState) {
      var nextState = __assign({}, prevQueryState);
      return __assign(__assign({}, nextState), {
        sort: sort
      });
    });
  };
  var setFilter = function setFilter(filter) {
    setQueryState(function (prevQueryState) {
      var _a;
      var nextState = __assign({}, prevQueryState);
      return __assign(__assign({}, nextState), {
        filter: __assign(__assign({}, nextState.filter), (_a = {}, _a[filter.key] = filter.value, _a))
      });
    });
  };
  var setPageSize = function setPageSize(pageSize) {
    setQueryState(function (prevQueryState) {
      var nextState = __assign({}, prevQueryState);
      return __assign(__assign({}, nextState), {
        pageSize: pageSize
      });
    });
  };
  var setPaging = function setPaging(paging) {
    setQueryState(function (prevQueryState) {
      var nextState = __assign({}, prevQueryState);
      return __assign(__assign({}, nextState), {
        paging: paging
      });
    });
  };
  // generate all values from the outlet
  var keyword = queryState.keyword,
    sort = queryState.sort,
    pageSize = queryState.pageSize,
    paging = queryState.paging,
    filter = queryState.filter,
    extraQueries = queryState.extraQueries;
  // derive the keywordTmp from keyword
  var _r = react_1.default.useState(keyword),
    keywordTmp = _r[0],
    setKeywordTmp = _r[1];
  // check if we can render sort or paging UI,
  // please notice that we already have a dedicated "canSearch" prop for search UI
  var canSort = !!sortOptions;
  var canPaging = !!pageSizeOptions;
  var _s = spec.actions,
    setLoading = _s.setLoading,
    fetchRecords = _s.fetchRecords,
    fetchRecordById = _s.fetchRecordById,
    deleteRecordById = _s.deleteRecordById;
  var fetchNextRecords = react_1.default.useCallback(function (_a) {
    var sort = _a.sort,
      keyword = _a.keyword,
      paging = _a.paging,
      filter = _a.filter,
      extraQueries = _a.extraQueries;
    return __awaiter(_this, void 0, void 0, function () {
      var params, validFilters, _filter, _i, validFilters_1, _b, key, value, resp;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            setRecords([]);
            params = {};
            if (canSort) {
              params.sort = sort;
            }
            if (canPaging) {
              params.paging = paging;
            }
            if (canSearch) {
              params.keyword = keyword;
            }
            params.extraQueries = extraQueries;
            validFilters = Object.keys(filter || {}).filter(function (k) {
              return filter[k] !== undefined;
            }).map(function (k) {
              return [k, filter[k]];
            });
            _filter = {};
            for (_i = 0, validFilters_1 = validFilters; _i < validFilters_1.length; _i++) {
              _b = validFilters_1[_i], key = _b[0], value = _b[1];
              try {
                value = JSON.parse(value);
              } catch (err) {}
              if (value === 'true') {
                _filter[key] = true;
              } else if (value === 'false') {
                _filter[key] = false;
              } else if (typeof value === 'object') {
                _filter = __assign(__assign({}, _filter), value); // option is query
              } else {
                _filter[key] = value;
              }
            }
            params.filter = _filter;
            return [4 /*yield*/, fetchRecords(params)];
          case 1:
            resp = _c.sent();
            if (Array.isArray(resp)) {
              setRecords(resp);
            } else {
              setRecords(resp.results);
              setTotalRecords(resp.total);
            }
            return [2 /*return*/];
        }
      });
    });
  }, [fetchRecords, canSort, canPaging, canSearch]);
  var smartFetchResource = react_1.useCallback(function () {
    return __awaiter(_this, void 0, void 0, function () {
      var _a, ex_1, ex_2;
      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            setLoading(true);
            if (!(action === 'detail')) return [3 /*break*/, 5];
            _b.label = 1;
          case 1:
            _b.trys.push([1, 3,, 4]);
            _a = setSelectedRecord;
            return [4 /*yield*/, fetchRecordById(id)];
          case 2:
            _a.apply(void 0, [_b.sent()]);
            return [3 /*break*/, 4];
          case 3:
            ex_1 = _b.sent();
            console.warn(ex_1);
            return [3 /*break*/, 4];
          case 4:
            return [3 /*break*/, 8];
          case 5:
            _b.trys.push([5, 7,, 8]);
            return [4 /*yield*/, fetchNextRecords({
              sort: sort,
              keyword: keyword,
              paging: paging,
              filter: filter,
              extraQueries: extraQueries
            })];
          case 6:
            _b.sent();
            return [3 /*break*/, 8];
          case 7:
            ex_2 = _b.sent();
            console.warn(ex_2);
            return [3 /*break*/, 8];
          case 8:
            setLoading(false);
            return [2 /*return*/];
        }
      });
    });
  }, [action, extraQueries, fetchNextRecords, fetchRecordById, filter, id, keyword, paging, setLoading, sort]);
  react_1.default.useEffect(function () {
    smartFetchResource();
  }, [smartFetchResource]);
  react_1.default.useEffect(function () {
    if (action !== 'detail') {
      setSelectedRecord(null);
    }
  }, [action]);
  var hasCreateButton = typeof renderCreateButton === 'undefined' || typeof renderCreateButton === 'function';
  var hasExtraDetailButton = typeof renderDetailButton === 'function';
  var hasDeleteButton = typeof renderDeleteButton === 'undefined' || typeof renderDeleteButton === 'function';
  var clientCallbacks = react_1.useMemo(function () {
    return {
      refresh: function refresh() {
        return __awaiter(_this, void 0, void 0, function () {
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                return [4 /*yield*/, smartFetchResource()];
              case 1:
                return [2 /*return*/, _a.sent()];
            }
          });
        });
      }
    };
  }, [smartFetchResource]);
  function transformColumns() {
    var _this = this;
    var columns = __spreadArray([], spec.columns);
    var _goToDetail = function _goToDetail(record) {
      if (onGoToDetail) {
        onGoToDetail(record);
      } else {
        AppActions.navigate(spec.path + "?action=detail&" + spec.primaryKey + "=" + record[spec.primaryKey]);
      }
    };
    if (hasExtraDetailButton) {
      columns.push({
        title: '',
        key: 'action',
        render: function render(_, record) {
          return renderDetailButton(record, clientCallbacks);
        }
      });
    }
    if (hasDeleteButton) {
      columns.push({
        title: '',
        key: 'action-delete',
        render: renderDeleteButton ? function (_, record) {
          return renderDeleteButton(record, clientCallbacks);
        } : function (_, record) {
          return react_1.default.createElement(antd_1.Button, {
            danger: true,
            className: "resource-delete-button",
            onClick: function onClick() {
              return __awaiter(_this, void 0, void 0, function () {
                var ex_3;
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      if (!deleteRecordById) {
                        return [2 /*return*/];
                      }

                      _a.label = 1;
                    case 1:
                      _a.trys.push([1, 4, 5, 6]);
                      setLoading(true);
                      return [4 /*yield*/, deleteRecordById(record[spec.primaryKey])];
                    case 2:
                      _a.sent();
                      return [4 /*yield*/, fetchNextRecords({
                        sort: sort,
                        keyword: keyword,
                        paging: paging,
                        filter: filter,
                        extraQueries: extraQueries
                      })];
                    case 3:
                      _a.sent();
                      return [3 /*break*/, 6];
                    case 4:
                      ex_3 = _a.sent();
                      console.warn(ex_3);
                      return [3 /*break*/, 6];
                    case 5:
                      setLoading(false);
                      return [7 /*endfinally*/];
                    case 6:
                      return [2 /*return*/];
                  }
                });
              });
            }
          }, "\u522A\u9664");
        }
      });
    }
    if (!hasExtraDetailButton && !spec.disableDetailRoute) {
      columns[0] = __assign({
        render: function render(text, record) {
          return react_1.default.createElement(antd_1.Button, {
            type: "link",
            onClick: function onClick() {
              return _goToDetail(record);
            }
          }, text || '--');
        }
      }, columns[0]);
    }
    return columns;
  }
  var modifiedColumns = transformColumns();
  if (action === 'create') {
    return react_1.default.createElement(Wrapper, {
      style: style
    }, react_1.default.createElement(Row, null, react_1.default.createElement(BackButton, {
      className: "resource-back-button",
      onClick: function onClick() {
        return AppActions.navigate(spec.backPath || spec.path);
      }
    }, react_1.default.createElement(ChevronLeft_1.ChevronLeft, {
      size: 24
    }), react_1.default.createElement("div", {
      className: "back-btn-text"
    }, spec.backTitle || '返回')), react_1.default.createElement("h1", {
      style: {
        marginLeft: 10
      }
    }, "\u5275\u5EFA" + spec.name)), renderDetail({
      instance: null,
      clientCallbacks: clientCallbacks
    }));
  } else if (action === 'detail') {
    return react_1.default.createElement(Wrapper, {
      style: style
    }, react_1.default.createElement(Row, null, react_1.default.createElement(BackButton, {
      className: "resource-back-button",
      onClick: function onClick() {
        return AppActions.navigate(spec.backPath || spec.path);
      }
    }, react_1.default.createElement(ChevronLeft_1.ChevronLeft, {
      size: 24
    }), react_1.default.createElement("div", {
      className: "back-btn-text"
    }, spec.backTitle || '返回')), react_1.default.createElement("h1", {
      style: {
        marginLeft: 10
      }
    }, spec.name + "\u8A73\u60C5")), selectedRecord && renderDetail({
      instance: selectedRecord,
      clientCallbacks: clientCallbacks
    }));
  } else {
    var onBulkWrite = function onBulkWrite(e, data) {
      return __awaiter(_this, void 0, void 0, function () {
        var actions, e_1;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              actions = bulkSelectedRecords.map(function (r) {
                var _a;
                return {
                  method: 'update_one',
                  payload: {
                    query: JStorageCompat_1._convertQuery((_a = {}, _a[spec.primaryKey] = r[spec.primaryKey], _a)),
                    data: data
                  }
                };
              });
              _a.label = 1;
            case 1:
              _a.trys.push([1, 3, 4, 5]);
              setLoading(true);
              return [4 /*yield*/, index_1.JStorage.bulkWriteDocuments(collection, actions)];
            case 2:
              _a.sent();
              return [3 /*break*/, 5];
            case 3:
              e_1 = _a.sent();
              antd_1.message.error('批次處理請求失敗，請稍後再嘗試。');
              return [2 /*return*/];
            case 4:
              setLoading(false);
              return [7 /*endfinally*/];
            case 5:
              _a.trys.push([5,, 7, 8]);
              setLoading(true);
              return [4 /*yield*/, fetchNextRecords({
                sort: sort,
                keyword: keyword,
                paging: paging,
                filter: filter,
                extraQueries: extraQueries
              })];
            case 6:
              _a.sent();
              return [3 /*break*/, 8];
            case 7:
              setLoading(false);
              return [7 /*endfinally*/];
            case 8:
              setBulkWriteModalVisible(false);
              return [2 /*return*/];
          }
        });
      });
    };

    return react_1.default.createElement(Wrapper, {
      style: style
    }, renderCustomSection && renderCustomSection({
      records: records,
      setRecords: setRecords,
      queryState: queryState,
      setQueryState: setQueryState,
      totalRecords: totalRecords,
      setTotalRecords: setTotalRecords,
      position: 'top'
    }), !!renderHeader ? renderHeader({
      spec: spec,
      clientCallbacks: clientCallbacks,
      onCreate: function onCreate() {
        if (_onCreate) {
          _onCreate();
        } else {
          AppActions.navigate(spec.path + "?action=create");
        }
      }
    }) : react_1.default.createElement(Row, null, react_1.default.createElement("h1", {
      style: {
        marginRight: 10
      }
    }, "" + spec.name), hasCreateButton && (renderCreateButton ? renderCreateButton({
      clientCallbacks: clientCallbacks
    }) : react_1.default.createElement(antd_1.Button, {
      onClick: function onClick() {
        if (_onCreate) {
          _onCreate();
        } else {
          AppActions.navigate(spec.path + "?action=create");
        }
      }
    }, "+"))), (canPaging || canSort || canSearch) && react_1.default.createElement("div", {
      style: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        margin: '10px 0'
      }
    }, canPaging && react_1.default.createElement("div", {
      style: {
        width: 80
      }
    }, react_1.default.createElement("div", null, "\u6BCF\u9801\u986F\u793A"), react_1.default.createElement(antd_1.Select, {
      value: pageSize,
      onChange: function onChange(nextPageSize) {
        setPageSize(nextPageSize);
        setPaging({
          offset: 0,
          limit: nextPageSize
        });
      }
    }, pageSizeOptions.map(function (opt) {
      return react_1.default.createElement(antd_1.Select.Option, {
        key: opt,
        value: opt
      }, opt);
    }))), canSort && react_1.default.createElement("div", {
      style: {
        width: 120,
        marginRight: 10
      }
    }, react_1.default.createElement("div", null, "\u6392\u5E8F"), react_1.default.createElement(antd_1.Select, {
      value: sort,
      onChange: function onChange(nextSort) {
        setSort(nextSort);
        setPaging({
          offset: 0,
          limit: pageSize
        });
      }
    }, sortOptions.map(function (opt) {
      return react_1.default.createElement(antd_1.Select.Option, {
        key: opt.value,
        value: opt.value
      }, opt.name);
    }))), canSearch && react_1.default.createElement("div", {
      style: {
        width: 300
      }
    }, react_1.default.createElement("div", {
      className: "resource-search-keyword"
    }, "\u641C\u5C0B ", keyword ? "\"" + keyword + "\"" : ''), react_1.default.createElement(antd_1.Input.Search, {
      value: keywordTmp,
      onChange: function onChange(e) {
        return setKeywordTmp(e.target.value);
      },
      onSearch: function onSearch() {
        setKeyword(keywordTmp);
        setPaging({
          offset: 0,
          limit: pageSize
        });
      },
      placeholder: searchPlaceHolder
    }))), filters && Array.isArray(filters) && filters.length > 0 && react_1.default.createElement("div", {
      className: "rsdk resource filters"
    }, filters.map(function (f, idx) {
      return react_1.default.createElement("div", {
        key: idx,
        className: "filter-item-wrapper"
      }, react_1.default.createElement("div", {
        style: {
          marginRight: 10
        }
      }, f.name), react_1.default.createElement(antd_1.Select, {
        placeholder: '不設定',
        style: {
          minWidth: 100
        },
        allowClear: true,
        dropdownMatchSelectWidth: true,
        value: filter[f.key] || null,
        onChange: function onChange(nextValue) {
          setFilter({
            key: f.key,
            value: nextValue
          });
          setPaging({
            offset: 0,
            limit: pageSize
          });
        }
      }, f.options.map(function (opt) {
        var val = JSON.stringify(opt.query || opt.value || '');
        return react_1.default.createElement(antd_1.Select.Option, {
          key: val,
          value: val
        }, opt.name);
      })));
    })), canBulkWrite && react_1.default.createElement(antd_1.Button, {
      disabled: bulkSelectedRecords.length <= 0,
      onClick: function onClick() {
        setBulkWriteModalVisible(true);
      }
    }, "\u6279\u6B21\u66F4\u65B0"), renderCustomSection && renderCustomSection({
      records: records,
      setRecords: setRecords,
      queryState: queryState,
      setQueryState: setQueryState,
      totalRecords: totalRecords,
      setTotalRecords: setTotalRecords,
      position: 'middle'
    }), react_1.default.createElement(antd_1.Table, __assign({
      rowSelection: canBulkWrite ? {
        type: 'checkbox',
        onChange: function onChange(_selectedRowKeys, selectedRows) {
          setBulkSelectedRecords(selectedRows);
        }
      } : undefined,
      dataSource: records,
      columns: modifiedColumns,
      rowKey: spec.primaryKey,
      pagination: !canPaging ? false : {
        size: 'small',
        total: totalRecords,
        showSizeChanger: false,
        showTotal: function showTotal(total) {
          return "\u5171 " + total + " \u7B46";
        },
        current: paging.offset / pageSize + 1,
        pageSize: pageSize,
        position: ['topRight'],
        onChange: function onChange(page, pageSize) {
          if (pageSize) {
            setPaging({
              offset: (page - 1) * pageSize,
              limit: pageSize
            });
          }
        }
      }
    }, resourceTableProps)), react_1.default.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center',
        padding: '20px 0'
      }
    }, react_1.default.createElement(antd_1.Button, {
      size: "large",
      className: "resource-refresh-button",
      onClick: function onClick() {
        return __awaiter(_this, void 0, void 0, function () {
          var ex_4;
          return __generator(this, function (_a) {
            switch (_a.label) {
              case 0:
                _a.trys.push([0, 2, 3, 4]);
                setLoading(true);
                return [4 /*yield*/, fetchNextRecords({
                  sort: sort,
                  keyword: keyword,
                  paging: paging,
                  filter: filter,
                  extraQueries: extraQueries
                })];
              case 1:
                _a.sent();
                return [3 /*break*/, 4];
              case 2:
                ex_4 = _a.sent();
                console.warn(ex_4);
                return [3 /*break*/, 4];
              case 3:
                setLoading(false);
                return [7 /*endfinally*/];
              case 4:
                return [2 /*return*/];
            }
          });
        });
      },

      style: {
        margin: 10
      }
    }, "\u91CD\u65B0\u6574\u7406")), renderCustomSection && renderCustomSection({
      records: records,
      setRecords: setRecords,
      queryState: queryState,
      setQueryState: setQueryState,
      totalRecords: totalRecords,
      setTotalRecords: setTotalRecords,
      position: 'bottom'
    }), react_1.default.createElement(BulkWriteFormModal, {
      visible: bulkWriteModalVisible,
      bulkWriteFormSpec: bulkWriteFormSpec,
      onOk: onBulkWrite,
      onCancel: function onCancel() {
        setBulkWriteModalVisible(false);
      }
    }));
  }
}
var Wrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 20px;\n\n  & h1 {\n    font-size: 32px;\n    margin: 0;\n  }\n\n  & .resource.filters {\n    display: flex;\n    flex-wrap: wrap;\n\n    & .filter-item-wrapper {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n      margin-right: 20px;\n    }\n  }\n\n  ", "\n"], ["\n  padding: 20px;\n\n  & h1 {\n    font-size: 32px;\n    margin: 0;\n  }\n\n  & .resource.filters {\n    display: flex;\n    flex-wrap: wrap;\n\n    & .filter-item-wrapper {\n      display: flex;\n      align-items: center;\n      margin-bottom: 10px;\n      margin-right: 20px;\n    }\n  }\n\n  ", "\n"])), function (props) {
  return props.css;
});
var Row = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var BackButton = styled_components_1.default.button(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: none;\n  border-bottom: 1px solid transparent;\n  padding: 5px 10px 5px 0px;\n  background-color: transparent;\n  cursor: pointer;\n\n  & > .back-btn-text {\n    font-size: 1.2rem;\n  }\n\n  &:hover {\n    border-bottom: 1px solid black;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  outline: none;\n  border: none;\n  border-bottom: 1px solid transparent;\n  padding: 5px 10px 5px 0px;\n  background-color: transparent;\n  cursor: pointer;\n\n  & > .back-btn-text {\n    font-size: 1.2rem;\n  }\n\n  &:hover {\n    border-bottom: 1px solid black;\n  }\n"])));
exports.default = GenericResource;
var templateObject_1, templateObject_2, templateObject_3;